import * as React from 'react';

export const RotatePhone = (props: React.SVGProps<SVGSVGElement>) => (
	<svg width="50" height="50" viewBox="0 0 225 224" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#clip0_3358_204)">
			<path
				d="M160.324 70.6288C159.278 70.6288 158.231 70.2188 157.446 69.4064L120.192 30.7772C118.658 29.1876 118.703 26.6564 120.293 25.1212C121.881 23.59 124.412 23.6368 125.949 25.2228L163.203 63.8516C164.736 65.4416 164.692 67.9728 163.102 69.508C162.324 70.258 161.324 70.6288 160.324 70.6288Z"
				fill="black"
			/>
			<path
				d="M25.9492 123.852L63.2032 162.476C64.7364 164.066 64.6916 166.598 63.1016 168.133C62.3244 168.883 61.3244 169.254 60.3244 169.254C59.2776 169.254 58.2308 168.844 57.4456 168.031L20.1916 129.406C18.6584 127.816 18.7032 125.285 20.2932 123.75C21.8828 122.219 24.4144 122.266 25.9492 123.852Z"
				fill="black"
			/>
			<path
				d="M12.0161 99.8944H100.324V12.0156C100.324 5.3908 105.696 0 112.297 0H212.352C218.953 0 224.324 5.3908 224.324 12.0156V108H223.302C223.722 109.22 224 110.506 224 111.867V211.922C224 218.524 218.617 223.894 212.002 223.894H179.904H176H12.0161C5.39087 223.894 6.10352e-05 218.524 6.10352e-05 211.922V111.867C6.10352e-05 105.266 5.39087 99.8944 12.0161 99.8944ZM216.324 12.0156C216.324 9.8008 214.543 8 212.352 8H112.297C110.106 8 108.324 9.8008 108.324 12.0156V99.8944H176H179.904H212.002C212.36 99.8944 212.697 99.9692 213.047 100H216.324V12.0156ZM212.002 215.894C214.207 215.894 216 214.113 216 211.922V111.867C216 109.832 214.506 108.265 212.541 108H184V215.894H212.002ZM8.00006 211.922C8.00006 214.113 9.80087 215.894 12.0161 215.894H176V108H100.324V107.894H12.0161C9.80087 107.894 8.00006 109.676 8.00006 111.867V211.922Z"
				fill="black"
			/>
			<path
				d="M200 151.894C206.617 151.894 212 157.277 212 163.894C212 170.512 206.617 175.894 200 175.894C193.383 175.894 188 170.512 188 163.894C188 157.277 193.383 151.894 200 151.894ZM200 167.894C202.205 167.894 204 166.102 204 163.894C204 161.688 202.205 159.894 200 159.894C197.795 159.894 196 161.688 196 163.894C196 166.102 197.795 167.894 200 167.894Z"
				fill="black"
			/>
			<path
				d="M154.457 43.3868C153.434 43.3868 152.41 42.996 151.629 42.2148L132.242 22.828C130.68 21.2656 130.68 18.7344 132.242 17.172C133.805 15.6092 136.336 15.6092 137.899 17.172L157.285 36.5584C158.848 38.1212 158.848 40.6524 157.285 42.2148C156.504 42.996 155.481 43.3868 154.457 43.3868Z"
				fill="black"
			/>
			<path
				d="M54.4572 142.016C53.4336 142.016 52.4104 141.625 51.6292 140.844L32.2424 121.457C30.68 119.894 30.68 117.363 32.2424 115.801C33.8048 114.238 36.336 114.238 37.8988 115.801L57.2852 135.188C58.848 136.75 58.848 139.281 57.2852 140.844C56.504 141.625 55.4808 142.016 54.4572 142.016Z"
				fill="black"
			/>
			<path
				d="M80.3245 21.6564L21.9809 80H40.3245V88H12.3245C10.1157 88 8.32446 86.2108 8.32446 84V56H16.3245V74.3436L74.6681 16H56.3245V8H84.3245C86.5333 8 88.3245 9.7892 88.3245 12V40H80.3245V21.6564Z"
				fill="black"
			/>
		</g>
		<defs>
			<clipPath id="clip0_3358_204">
				<rect
					width="224.324"
					height="223.894"
					fill="white"
					transform="matrix(-1 0 0 1 224.324 0)"
				/>
			</clipPath>
		</defs>
	</svg>
);
